import React, { FC } from "react";
import clsx from "clsx";
import { PProps } from "./P.props";

const PComponent: FC<PProps> = ({
	size = "p1",
	type = "regular",
	children,
	className = "",
	dangerouslySetInnerHTML,
	...props
}): JSX.Element => {
	const sizeClasses: Record<PProps["size"], string> = {
		p1: "minPhone:text-p3 lg:text-p1",
		p2: "minPhone:text-t1 lg:text-p2",
		p3: "minPhone:text-t1 lg:text-p3",
		t1: "minPhone:text-t2 lg:text-t1",
		t2: "minPhone:text-t2 lg:text-t2",
		t3: "minPhone:text-t3 lg:text-t3", // ✅ added
	};

	const typeClasses: Record<PProps["type"], string> = {
		light: "font-light",
		regular: "font-normal",
		medium: "font-medium",
		semibold: "font-semibold",
		bold: "font-bold",
	};

	const classnames = clsx(
		"cursor-default font-sans",
		sizeClasses[size],
		typeClasses[type],
		className,
	);

	const contentProps = dangerouslySetInnerHTML
		? { dangerouslySetInnerHTML }
		: { children };

	return <p className={classnames} {...props} {...contentProps} />;
};

PComponent.displayName = "P"; // ✅ ESLint fix

const P = React.memo(PComponent);
export default P;
